import { Button, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../app/hooks";
import { reasonForTemporaryEmploymentOptions } from "../../../constants";
import { OrderType } from "../../../orderAPI";
import { FormTitleGrid } from "../../../styles";
import { OrderTesVariation } from "../../../orderTesVariation/OrderTesVariation";
import { useState } from "react";
import FormSection from "../../../../../common/components/functional/formSection/FormSection";

export const Terms = () => {
  const { t } = useTranslation("order");
  const { control, watch, setValue } = useFormContext();
  const { orderTemplate, type, workStarts, tesVariation, isReadOnly } = watch();

  const { tes: localizedTes } = useAppSelector((state) => state.localized);

  const [tesSettingsOpen, setTesSettingsOpen] = useState(false);

  const onTesVariationChange = (newVariations: any) => {
    setValue(`tesVariation`, newVariations, { shouldDirty: true });
  };

  const onClose = () => {
    setTesSettingsOpen(false);
  };

  return (
    <FormSection title={t("termsOfEmployment")}>
      {type === OrderType.FixedTerm && (
        <>
          <FormTitleGrid container item xs={4}>
            <Typography variant="secondary">
              {t("talentProfile:reasonForTemporaryEmployment")}
            </Typography>
          </FormTitleGrid>
          <Grid item xs={8}>
            <Controller
              name="reasonForTemporaryEmployment"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  select
                  fullWidth
                  sx={{
                    backgroundColor: "rgba(249, 249, 250, 0.6)",
                    width: "363px",
                  }}
                  size="small"
                  name="reasonForTemporaryEmployment"
                  value={field.value}
                  disabled={isReadOnly}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                  }}
                >
                  {reasonForTemporaryEmploymentOptions
                    .sort((a, b) => t(a.label).localeCompare(t(b.label)))
                    .map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {t(option.label)}
                      </MenuItem>
                    ))}
                </TextField>
              )}
            />
          </Grid>
        </>
      )}
      {/* REVIEW - refactor TesRow and use it here? */}
      <FormTitleGrid container item xs={4}>
        <Typography variant="secondary">{t("common:tes")}</Typography>
      </FormTitleGrid>
      <Grid item xs={8}>
        <TextField
          disabled
          size="small"
          select
          value={orderTemplate?.tesId || ""}
          sx={{ width: "363px" }}
        >
          <MenuItem value={orderTemplate?.tesId || ""}>
            {orderTemplate?.tesId ? localizedTes[orderTemplate.tesId] : ""}
          </MenuItem>
        </TextField>
        <Button
          sx={{ textTransform: "none", marginLeft: "0.5rem" }}
          variant="text"
          disabled={!orderTemplate?.tesId || !workStarts || isReadOnly}
          onClick={() => setTesSettingsOpen(true)}
        >
          {t("common:settingsDots")}
        </Button>
        <OrderTesVariation
          tesId={orderTemplate?.tesId}
          variationDefaults={tesVariation}
          date={workStarts}
          open={tesSettingsOpen}
          onClose={onClose}
          setTesVariation={onTesVariationChange}
        />
      </Grid>
    </FormSection>
  );
};
